
















import Vue from 'vue'
import { FilterItems } from '@/types/service-response'

interface ComponentData {
  selectedItem: { FilterItemId: number | undefined, FilterItemValue: string | undefined }
  selectRules: Array<(v: string) => string | boolean>
}

interface Payload {
  name: string
  value: string
  label: string
}

export default Vue.extend({
  name: 'ReportingMonthSelect',

  props: {
    name: String,
    label: String,
    items: {
      type: Array as () => Array<FilterItems>
    },
    defaulValue: String,
    isRequired: Boolean,
    isValid: Boolean
  },

  data (): ComponentData {
    return {
      selectedItem: { FilterItemId: undefined, FilterItemValue: undefined },
      selectRules: [
        (v) => {
          if (this.isRequired) {
            return !!v || this.$t('reportingFilter.valueIsRequired').toString()
          } else {
            return true
          }
        }
      ],
    }
  },

  computed: {
    monthItems () {
      let monthItems: Array<{ FilterItemId: number, FilterItemValue: string }> = [
        { FilterItemId: 1, FilterItemValue: this.$t('reportingFilter.January').toString() },
        { FilterItemId: 2, FilterItemValue: this.$t('reportingFilter.February').toString() },
        { FilterItemId: 3, FilterItemValue: this.$t('reportingFilter.March').toString() },
        { FilterItemId: 4, FilterItemValue: this.$t('reportingFilter.April').toString() },
        { FilterItemId: 5, FilterItemValue: this.$t('reportingFilter.May').toString() },
        { FilterItemId: 6, FilterItemValue: this.$t('reportingFilter.June').toString() },
        { FilterItemId: 7, FilterItemValue: this.$t('reportingFilter.July').toString() },
        { FilterItemId: 8, FilterItemValue: this.$t('reportingFilter.August').toString() },
        { FilterItemId: 9, FilterItemValue: this.$t('reportingFilter.September').toString() },
        { FilterItemId: 10, FilterItemValue: this.$t('reportingFilter.October').toString() },
        { FilterItemId: 11, FilterItemValue: this.$t('reportingFilter.November').toString() },
        { FilterItemId: 12, FilterItemValue: this.$t('reportingFilter.December').toString() },
      ]
      return monthItems
    }
  },

  watch: {
    isValid (newVal: boolean): void {
      if (newVal === true) {
        const form: any = this.$refs['form']
        form.validate()
      }
    }
  },

  methods: {

    onMonthChange (): void {
      if (this.name && this.selectedItem && this.selectedItem.FilterItemId) {
        let payload: Payload = { name: this.name, value: this.selectedItem.FilterItemId.toString(), label: this.selectedItem.FilterItemValue ? this.selectedItem.FilterItemValue : ''}
        this.$emit('onMonthChange', payload)
      }
    }
  },

  created () {
    if (this.defaulValue) {
      this.selectedItem = { FilterItemId: undefined, FilterItemValue: undefined }
      this.selectedItem.FilterItemId = parseInt(this.defaulValue)

      if (this.name && this.selectedItem) {
        this.$emit('onMonthChange', this.selectedItem)
      }
    }
  }

})
